
























































































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import EconomicCalculationSection from '../common/EconomicCalculationSection.vue';
import CalculatorInputField from '../../CalculatorInputField.vue';
import { DropdownOption } from '@/models/swine/dropdown.model';
import ReferenceTypeDropdown from '../../ReferenceTypeDropdown.vue';
import {
  EconomicCalculationModalDataType,
  PulmotilCalculationModalData,
} from '@/models/swine/economic-calculation.model';
@Component({
  components: {
    EconomicCalculationSection,
    CalculatorInputField,
    ReferenceTypeDropdown,
  },
})
export default class PulmotilCalculationForm extends Vue {
  calculatorModalInputObject: Partial<PulmotilCalculationModalData> = {
    additionalFeedCostPigRate: null,
    adfiValue: null,
    adgValue: null,
    averageFeedPrice: null,
    averageLitterSizeBornAlive: null,
    economicCalculationType: null,
    liveWeightPrice: null,
    nurseryMortality: null,
    preWeaningMortality: null,
    referenceType: null,
    sowIndex: null,
    sowLevel: null,
    targetMarketWeight: null,
    weanMarketDays: null,
    weekNumber: null,
    ageOfWeaning: null,
  };

  @Prop()
  previousInput!: EconomicCalculationModalDataType;

  @Prop({ required: true })
  references!: DropdownOption[];

  @Prop({ required: true })
  currentCurrency!: string;

  @Watch(`previousInput`)
  updateData() {
    if (this.previousInput) {
      this.calculatorModalInputObject = this.previousInput;
    }
  }

  selectedReferenceType({ value }: DropdownOption) {
    this.calculatorModalInputObject.referenceType = value;
    this.returnForm();
  }

  calculateWeekNumber() {
    let numberOfDays = 0;

    if (
      this.calculatorModalInputObject.weanMarketDays &&
      Number(this.calculatorModalInputObject.weanMarketDays)
    ) {
      numberOfDays += Number(this.calculatorModalInputObject.weanMarketDays);
    }

    if (
      this.calculatorModalInputObject.ageOfWeaning &&
      Number(this.calculatorModalInputObject.ageOfWeaning)
    ) {
      numberOfDays += Number(this.calculatorModalInputObject.ageOfWeaning);
    }

    const remainderDays = numberOfDays % 7;
    const noOfWeeks = Math.floor(numberOfDays / 7);
    if (remainderDays >= 4 || noOfWeeks === 0) {
      this.calculatorModalInputObject.weekNumber = noOfWeeks + 1;
    } else {
      this.calculatorModalInputObject.weekNumber = noOfWeeks;
    }
    this.returnForm();
  }

  @Emit('update')
  returnForm() {
    return this.calculatorModalInputObject;
  }
}
